import PushedScreen from "../../components/PushedScreen/PushedScreen"
import { usePostPurchase } from "../../context/postPurchaseContext"
import useQueryParams from "../../hooks/useQueryParams"
import MonthlyToYearlyPaywall from "./MonthlyToYearlyPaywall/MonthlyToYearlyPaywall"
import PremiumToUltimatePaywall from "./PremiumToUltimatePaywall/PremiumToUltimatePaywall"

const PostPurchasePaywalls = () => {
  const flow = usePostPurchase().state.visibleFlowType

  const monthlyToYearlyVisible = flow === "monthlyToYearly"
  const premiumToUltimateVisible = flow === "premiumToUltimate"

  return (
    <>
      <PushedScreen visible={monthlyToYearlyVisible}>
        <MonthlyToYearlyPaywall />
      </PushedScreen>
      <PushedScreen visible={premiumToUltimateVisible}>
        <PremiumToUltimatePaywall></PremiumToUltimatePaywall>
      </PushedScreen>
    </>
  )
}

export default PostPurchasePaywalls
